import { gql } from "@apollo/client";

export const DASHBOARD_IDS_BY_USER_GROUP_QUERY = gql`
  query dashboardIdsByUserGroup($userGroupId: Int!) {
    dashboardIdsByUserGroup(userGroupId: $userGroupId)
  }
`;

export const DASHBOARD_INDICATORS_QUERY = gql`
  query dashboardIndicators($userId: Int!, $groupName: String!, $dashboardId: Int!, $lang: String!) {
    dashboardIndicators(userId: $userId, groupName: $groupName, dashboardId: $dashboardId, lang: $lang) {
      id
      name
      title
      type
      orderNo
      pie {
        id
        value
        label
      }
      graphic {
        value
        month
        year
        type
        status
      }
    }
  }
`;
